import { getInfo, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters'

import { TYPES_MAPPING } from './DetailsFormatter'

export default function CustomFieldFormatter({ info, customFields }) {
  const { row: { integrationDataParsed, type } } = getInfo(info)
  const { cfid_number: id, cfid } = integrationDataParsed?.[TYPES_MAPPING[type]] || {}

  if (!id) {
    return '--'
  }

  const { label } = customFields.find(({ value }) => `${value}` === `${id}`) || {}

  return <TruncateWithTooltipFormatter value={label || cfid} />
}
